import { render, staticRenderFns } from "./ChangePeriodDialog.vue?vue&type=template&id=1e08b8b0&scoped=true"
import script from "./ChangePeriodDialog.vue?vue&type=script&lang=js"
export * from "./ChangePeriodDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e08b8b0",
  null
  
)

export default component.exports